import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import features from 'lib/common/features';
import { fetchHtml } from 'lib/common/fetcher';
import forEach from 'lodash/forEach';
import find from 'lodash/find';
import get from 'lodash/get';

import Details from 'components/Details';
import PromoCode from 'components/PromoCode';
import ReactTooltip from 'react-tooltip';
import { ACTIONS } from '../mediator';

var bestAvailableUrl = features.getOption('levelSelector', 'bestAvailableUrl');

const LevelSelectorContainer = React.createClass({
  propTypes: {
    details: PropTypes.object,
    loginInfo: PropTypes.object,
    performanceId: PropTypes.number,
    levelSelectorConfig: PropTypes.object.isRequired,
    onLevelSelected: PropTypes.func.isRequired,
    onPromoCodeReady: PropTypes.func.isRequired
  },
  getInitialState: function() {
    return {
      imageMask: null,
      isInactive: true,
      activeMask: null
    };
  },
  componentDidMount: function() {
    fetchHtml(this.props.levelSelectorConfig.imageMask).then(imageMask => {
      this.setState({
        imageMask: imageMask
      });
    });
  },
  componentDidUpdate() {
    if (
      !this.initialisedHotspots &&
      this._hotspotsEls &&
      this._hotspotsEls.length
    ) {
      var { levelSelectorConfig } = this.props;

      /**
             * Associate tool-tip labels with hit-areas
             */
      forEach(this._hotspotsEls, el => {
        var hitAreaLabel = find(
          levelSelectorConfig.hitAreaLabels,
          x => x.id === el.id
        );

        if (hitAreaLabel) {
          el.setAttributeNS(null, 'data-tip', hitAreaLabel.label);
        }
      });

      forEach(this._hotspotsEls, el => {
        el.addEventListener('mouseenter', () => {
          ReactTooltip.show(el);

          /**
                     * Force rendering, trigger mouse-move behaviour
                     */
          setTimeout(function() {
            ReactTooltip.rebuild();
          }, 0);

          this.setState({
            activeMask: el
          });
        });

        el.addEventListener('mouseleave', () => {
          ReactTooltip.hide();

          this.setState({
            activeMask: null
          });
        });

        el.addEventListener('click', () => {
          this.handleLevelSelection(el.id);
        });
      });

      this.initialisedHotspots = true;
    }
  },
  setAsActive: function() {
    this.setState({
      isInactive: false
    });
  },
  setAsInactive: function() {
    this.setState({
      isInactive: true
    });
  },
  handleLevelSelection(id) {
    var selector = id.replace('hit-area-', '');
    var newZoom = get(this.props.levelSelectorConfig, 'zoomLevel', 1);
    this.props.onLevelSelected(selector, newZoom);
  },
  handleLevelSelectionFallback: function(e) {
    e.preventDefault();
    var val = this._fallbackSelect.value;
    if (val) {
      this.handleLevelSelection(val);
    }
  },
  renderLevelSelectorGraphic: function() {
    /* eslint-disable react/no-danger */
    return (
      <div className="syos-level-selector">
        <div
          className={classnames({
            'syos-level-selector__header': true,
            'syos-level-selector__header--has-extra': features.isEnabled(
              'promoCode'
            )
          })}
        >
          <div className="syos-level-selector__header__details">
            <Details
              details={this.props.details}
              isAvailable={!!this.props.details}
            />
          </div>
          {features.isEnabled('promoCode') && (
            <div className="syos-level-selector__header__extra">
              <PromoCode
                loginInfo={this.props.loginInfo}
                onPromoCodeReady={this.props.onPromoCodeReady}
                selectedLevel={ACTIONS.LEVEL_SELECTOR_CONTAINER}
              />
            </div>
          )}
        </div>
        <div className="syos-level-selector__topbar">
          <div className="syos-level-selector__topbar__label">
            Select your preferred seating area
          </div>
          {bestAvailableUrl && (
            <div className="syos-level-selector__topbar__action">
              <a
                className="syos-button"
                href={`${bestAvailableUrl}${this.props.performanceId}`}
              >
                Best Available Seats
              </a>
            </div>
          )}
        </div>
        <div
          className="syos-level-selector__graphic"
          onMouseEnter={this.setAsActive}
          onMouseLeave={this.setAsInactive}
        >
          <div
            className="syos-level-selector__hotspots"
            ref={el => {
              if (el) {
                var svg = el.firstChild;
                this._hotspotsEls = svg.querySelectorAll("[id^='hit-area-']");
                this._hotspotsViewBox = svg.getAttribute('viewBox');
              }
            }}
            dangerouslySetInnerHTML={{
              __html: this.state.imageMask
            }}
          />

          {this.state.activeMask && (
            <svg
              className="syos-level-selector__mask"
              viewBox={this._hotspotsViewBox}
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
            >
              <defs>
                <clipPath
                  id="mask"
                  dangerouslySetInnerHTML={{
                    __html: new XMLSerializer().serializeToString(
                      this.state.activeMask
                    )
                  }}
                />
              </defs>
              <image
                xlinkHref={this.props.levelSelectorConfig.imageBackground}
                x="0"
                y="0"
                height="100%"
                width="100%"
                clipPath="url(#mask)"
              />
            </svg>
          )}

          <svg
            className="syos-level-selector__mask-image"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
          >
            <image
              xlinkHref={
                this.state.isInactive ? (
                  this.props.levelSelectorConfig.imageBackground
                ) : (
                  this.props.levelSelectorConfig.imageForeground
                )
              }
              x="0"
              y="0"
              height="100%"
              width="100%"
            />
          </svg>
        </div>
      </div>
    );
  },
  renderFallbackForm: function() {
    return (
      <form
        className="syos-level-selector-form"
        onSubmit={this.handleLevelSelectionFallback}
      >
        <label
          className="syos-level-selector-form__label"
          htmlFor="select-level-fallback"
        >
          Select your preferred seating area
        </label>
        <select
          className="syos-level-selector-form__select"
          id="select-level-fallback"
          ref={el => (this._fallbackSelect = el)}
        >
          <optgroup label="Select a level">
            {this.props.levelSelectorConfig.hitAreaLabels.map(item => {
              return (
                <option key={item.id} value={item.id}>
                  {item.label}
                </option>
              );
            })}
          </optgroup>
        </select>
        <input
          className="syos-level-selector-form__action syos-button"
          type="submit"
          value="Select"
        />

        {bestAvailableUrl && (
          <a
            className="syos-level-selector-form__best-available"
            href={`${bestAvailableUrl}${this.props.performanceId}`}
          >
            Or choose Best Available seats
          </a>
        )}
      </form>
    );
  },
  render: function() {
    return this.state.imageMask ? (
      <div className="syos-level-selector-container">
        {this.renderLevelSelectorGraphic()}
        {this.renderFallbackForm()}
        <ReactTooltip />
      </div>
    ) : null;
  }
});

export default LevelSelectorContainer;



// WEBPACK FOOTER //
// ./src/javascripts/app/containers/LevelSelectorContainer.js